import React, { useEffect, useState } from 'react';
import './profile.css';

function Profile() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    try {
      const stored = localStorage.getItem('user');
      const parsed = JSON.parse(stored);
      if (parsed && typeof parsed === 'object') {
        setUser(parsed);
      } else {
        setUser(null);
      }
    } catch (err) {
      console.error('Invalid user in localStorage:', err);
      setUser(null);
    }
  }, []);

  const avatarUrl = user?.avatar
    ? `https://kotya.space/avatars/${user.id}/${user.avatar}`
    : '/avatar.png';

  const displayName = user?.name || 'Гість';

  return (
    <div className="profile-container">
      <img className="profile-avatar" src={avatarUrl} alt="avatar" />
      <h2>{displayName}</h2>
      <button className="logout-button" onClick={() => {
        localStorage.clear();
        window.location.href = '/login';
      }}>
        Вийти
      </button>
    </div>
  );
}

export default Profile;